import React, {Component} from 'react';
import InvestorsRecruitItem from '../InvestorsRecruitItem';
import {ListContainer, NotHasMore, NoData} from './style';
import {observer} from "mobx-react";
import {InfiniteLoader} from '@jdcfe/yep-react';
import noDataImg from '../../../assets/image/no_data.png';
import unit_institution from "../../../store/asset_institution/unit_institution";
import ChuzhiNoticeItem from '../ChuzhiNoticeItem';

@observer
class ChuzhiNoticeList extends Component {
  constructor(props) {
    super(props);
  }

  onScroll = (e) => {
  }

  loadMore = () => {
    const {isLoadNext} = this.props
    if(isLoadNext===false){
      return
    }
    const {getChuzhiNoticeList} = this.props.store;
    if (unit_institution.curTabIndex === 3) {
      getChuzhiNoticeList(unit_institution.vendorId);
    }
  }

  render() {
    const {chuzhiNoticeList, chuzhiNoticeListHasMore} = this.props.store;
    return (
      <div>
        {unit_institution.curTabIndex === 3 &&
        <ListContainer style={{ paddingBottom: '0.6rem' }}>
          {chuzhiNoticeList && chuzhiNoticeList.length !== 0 && (<InfiniteLoader
            dataLength={chuzhiNoticeList.length}
            hasMore={chuzhiNoticeListHasMore}
            onScroll={(e) => {
              this.onScroll(e);
            }}
            loadMore={() => {
              this.loadMore();
            }}
          >
            {chuzhiNoticeList.length !== 0 && chuzhiNoticeList.map(
              value => (<ChuzhiNoticeItem
                key={value.id}
                itemInfo={value}
              ></ChuzhiNoticeItem>))
            }
            {
              chuzhiNoticeList.length !== 0 && !chuzhiNoticeListHasMore &&
              (
                <NotHasMore>
                  没有更多啦~
                </NotHasMore>
              )
            }
          </InfiniteLoader>)}

          {
            chuzhiNoticeList.length === 0 &&
            (
              <NoData style={{'background': '#fff'}}>
                <img src={noDataImg} alt=""/>
                <p>暂无相关处置公告，敬请期待～</p>
              </NoData>
            )
          }
        </ListContainer>
        }
      </div>
    )
  }
}

export default ChuzhiNoticeList;
